import React, { useRef } from "react";

export default function OTPInput({ length = 6, value, onChange, onComplete, disabled }) {
  const refs = useRef([]);

  const handleChange = (idx, e) => {
    const v = e.target.value.replace(/\D/g, "").slice(-1);
    const arr = (value || "").split("");
    arr[idx] = v;
    const next = arr.join("").slice(0, length);
    onChange(next);
    if (v && idx < length - 1) refs.current[idx + 1]?.focus();
    if (next.length === length && onComplete) onComplete(next);
  };

  const handleKey = (idx, e) => {
    if (e.key === "Backspace" && !value?.[idx] && idx > 0) {
      refs.current[idx - 1]?.focus();
    }
    if (e.key === "ArrowLeft" && idx > 0) refs.current[idx - 1]?.focus();
    if (e.key === "ArrowRight" && idx < length - 1) refs.current[idx + 1]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    onChange(pasted);
    if (pasted.length === length && onComplete) onComplete(pasted);
    const target = Math.min(pasted.length, length - 1);
    refs.current[target]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center" data-testid="otp-input">
      {Array.from({ length }).map((_, idx) => (
        <input
          key={idx}
          ref={(el) => (refs.current[idx] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value?.[idx] || ""}
          onChange={(e) => handleChange(idx, e)}
          onKeyDown={(e) => handleKey(idx, e)}
          onPaste={handlePaste}
          disabled={disabled}
          className="input2 t-mono"
          style={{ width: 52, height: 56, textAlign: "center", fontSize: 22, fontWeight: 600, padding: 0 }}
          data-testid={`otp-digit-${idx}`}
        />
      ))}
    </div>
  );
}
